// Spanish translation

const es = {
  "menu.hotel_rack": "RACK",
  "hotel.rack.add_booking": "Booking",
  "hotel.rack.add_maintenance": "Mantenimiento",
  "hotel.rack.operation_center": "Operation Center",
  "hotel.rack.lockout_added": "Bloqueo agregado exitosamente!",
  "maintenance.request_service": "Ordenes de Servicio",
  "maintenance.request_service.priority": "Prioridad",
  "maintenance.request_service.description": "Descripción",
  "maintenance.request_service.number": "Número",
  "maintenance.request_service.room": "Habitación",
  "maintenance.request_service.start_date": "Fecha de inicio",
  "maintenance.request_service.end_date": "Fecha de fin",
  "maintenance.request_service.total_days": "Total Días",
  "maintenance.request_service.assigned": "Asignar",
  "maintenance.request_service.state": "Estado",
  "maintenance.request_service.approved_notes":"Notas de Aprobación"
};

export default es;
